<template>
  <div class="report-firewall-transactions">
    <div class="search-area">
      <el-select v-model="query.by" placeholder="Select">
        <el-option
          v-for="item in [
            { label: 'Date', value: 'date' },
            { label: 'Year', value: 'year' },
          ]"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-select v-model="query.year" placeholder="Year" style="width:100px" v-if="query.by === byYear">
            <el-option
                v-for="item in year_option"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
          </el-select>

      <el-date-picker
        v-model="dateSearch"
        type="daterange"
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        v-else
      >
      </el-date-picker>
      <el-button
        slot="append"
        type="primary"
        icon="el-icon-search"
        @click="getTransactionsFirewall()"
        :loading="loading"
        >Search</el-button
      >
      <el-button icon="el-icon-download" type="success" @click="Report()"
        >Export</el-button
      >
    </div>

    <data-tables 
          v-loading="loading" 
          :data="tableData" 
          border 
          :page-size="10"
          :pagination-props="{ background: true, pageSizes: [10, 20, 50, 100, 200] }">
          <el-table-column prop="caseId" label="Case ID" header-align="center" align="center" width="100" fixed="left"> </el-table-column>
          <el-table-column prop="memberCode" label="Member" header-align="center" align="center" min-width="80"> </el-table-column>
          <el-table-column prop="bankholderId" label="BankholderID" header-align="center" align="center" min-width="120"></el-table-column>
          <el-table-column prop="amount" label="Amount" header-align="center" align="center" min-width="120"></el-table-column>
          <el-table-column prop="currency" label="Currency" header-align="center" align="center" min-width="90"> </el-table-column>
          <el-table-column prop="status" label="Status" header-align="center" align="center" min-width="120">
            <template slot-scope="scope">        
              <el-tag v-if="scope.row.status == 'wait'" type="info">{{scope.row.status}}</el-tag>
              <el-tag v-if="scope.row.status == 'decline'" type="danger">{{scope.row.status}}</el-tag>    
              <el-tag v-if="scope.row.status == 'approve'" type="success">{{scope.row.status}}</el-tag>
              <el-tag v-if="scope.row.status == 'OK'" >{{scope.row.status}}</el-tag>
          </template>
          </el-table-column>
          <!-- <el-table-column prop="firewallHit" label="Firewall" header-align="center" align="center" width="100" > </el-table-column> -->
          <el-table-column prop="hitReason" label="Reason" header-align="center" align="center" width="300"> </el-table-column>
          <!-- <el-table-column prop="payeeName" label="Payee name" header-align="center" align="center" width="200"> </el-table-column>
          <el-table-column prop="payeeAccountnumberIban" label="Payee Acc/IBAN" header-align="center" align="center" width="200"> </el-table-column>
          <el-table-column prop="payeeSortcodeBic" label="Payee Sortcode/BIC" header-align="center" align="center" width="100"> </el-table-column> -->
          <el-table-column prop="paymentType" label="Payment Type" header-align="center" align="center" width="120">
            <template slot-scope="scope">        
              <el-tag v-if="scope.row.paymentType == 'payout'" type="warning">{{scope.row.paymentType}}</el-tag>    
              <el-tag v-if="scope.row.paymentType == 'payin'">{{scope.row.paymentType}}</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="senderName" label="Sender Name" header-align="center" align="center" width="200"> </el-table-column>
          <el-table-column prop="senderAccountnumberIban" label="Sender Acc/IBAN" header-align="center" align="center" width="100"> </el-table-column>
          <el-table-column prop="senderSortcodeBic" label="Sender Sortcode/BIC" header-align="center" align="center" width="100"> </el-table-column> -->
          <el-table-column prop="createdDate" label="Date" header-align="center" align="center" min-width="150"> </el-table-column>
          <el-table-column prop="paymentuid" label="Action" header-align="center" align="center" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="showDetail(scope.row.paymentuid)"
              >
                Detail
              </el-button>
            </template>
          </el-table-column>

        </data-tables>
  </div>
</template>

<script>
import { getFirewallTransactions, reportFirewallTransactionsExcel } from "@/api/firewall-report";
import { currentDateTime, dateFormat, currentYear} from "@/utils";
export default {
  props: {
    project: String,
  },
  watch: {
      project(val, old) {
        this.project = val;
        this.getTransactionsFirewall()
      }
  },
  data() {
    return {
      loading: false,
      dateSearch: "",
      byDate: "date",
      byYear: "year",
      tableData: [],
      year_option: [],
      query: {
        by: "date",
        year: currentYear(),
        startDate: "",
        endDate: "",
      },
    };
  },
  methods: {
    SelectDate() {
      if (!this.project) {
        this.$confirm("Please select project", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        })
          .then(() => {})
          .catch(() => {});
        return false;
      }

      let formData = { ...this.query };
      if (formData.by === this.byDate) {
        delete formData.year;
        formData.startDate =
          this.dateSearch[0] ||
          currentDateTime("YYYY-MM-DD");
        formData.endDate =
          this.dateSearch[1] ||
          currentDateTime("YYYY-MM-DD");
      } else {
        delete formData.startDate;
        delete formData.endDate;
      }

      return formData;
    },
    getTransactionsFirewall() {
      const formData = this.SelectDate();
      if (!formData) return false;
      this.loading = true;
      getFirewallTransactions(this.project, formData).then(
        ({ result, data }) => {
          this.loading = false;
          if (result) {
            this.tableData = data
          }
        }
      );
    },
    Report() {
      const formData = this.SelectDate();
      if (!formData) return false;
      reportFirewallTransactionsExcel(this.project, formData)
    },
    showDetail(transactionid) {
     this.$router.push({
        name: "FirewallDetail",
        params: {
          transactionid: transactionid,
        },
      });
      //window.open(route.href, '_blank');
    },
    dropdownMonthYear() {
      for (let y = (currentYear() - 5); y <= currentYear(); y++) {
        this.year_option.push({ value: y.toString() });
      }
    },
  },

  created(){
    this.dropdownMonthYear()
  }

};
</script>

<style lang="scss">
.report-firewall-transactions {
  .search-area {
    margin-bottom: 16px;
    button {
      margin-left: 10px;
      margin-bottom: 16px;
    }
    .el-date-editor, .el-select {
      margin-left: 10px;
      margin-bottom: 16px;
    }
  }

  .el-tag{
    text-transform: capitalize;
  }
}
</style>